<script>
    import {onMount} from 'svelte';

    import store from '../../../Stores/grupo-store';
    import {validaGrupo} from '../../../Modelos/Grupo';

    import {url, goto} from '@sveltech/routify';

    import Loading from "../../../Components/UI/Loading.svelte";
    import Error from "../../../Components/UI/Error.svelte";
    import Titulo from "../../../Components/UI/Titulo.svelte";
    import Migas from "../../../Components/UI/Migas/Migas.svelte";
    import Miga from "../../../Components/UI/Migas/Miga.svelte";
    import Formulario from "../../../Components/Grupos/Edicion/Formulario.svelte";

    export let id;
    onMount(() => store.cargar(id));

    let grupo, error, errores;
    $: grupo = $store.grupo;
    $: errores = validaGrupo(grupo);
    $: error = $store.error;
</script>

<style>
    h2 .material-icons {
        font-size: 2.5em;
        vertical-align: bottom;
        line-height: 1;
    }

    @media (min-width: 1024px) {
        .fila {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: var(--padding-global);
        }

        .fila-3 {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-gap: var(--padding-global);
        }
    }
</style>

<svelte:head>
    <title>Nuevo grupo</title>
</svelte:head>

<Migas>
    <Miga url={$url('/grupos')}>Grupos</Miga>
    <Miga actual>Nuevo grupo</Miga>
</Migas>

<Titulo>Nuevo grupo</Titulo>

{#if $store.cargando}
    <Loading/>
{:else if error}
    <Error mensaje={error} on:cancel={() => error = null}/>
{:else if grupo}
    <Formulario on:enviado={() => $goto('/grupos')}/>
{/if}